import { fetchApi } from '@/services/api';

import type { Paginated } from '@/modules/demand-planning/types/consensus.types';

export interface ApprovalRow {
  id: number;
  planning_cycle: number;
  entity_type: string;
  entity_id: number;
  approval_role: string;
  status: string;
  decision_comment: string;
  approver_email: string | null;
  requested_at: string;
  decided_at: string | null;
}

export type ApprovalDecision = 'approved' | 'rejected' | 'skipped';

export const approvalsService = {
  listForCycle(planningCycleId: number, status?: string): Promise<ApprovalRow[]> {
    const params: Record<string, string | number> = {
      planning_cycle: planningCycleId,
      page_size: 200,
    };
    if (status) params.status = status;
    return fetchApi<Paginated<ApprovalRow>>('demand-planning/approvals/', { params }).then(
      (data) => data.results ?? [],
    );
  },

  decide(id: number, status: ApprovalDecision, comment?: string): Promise<ApprovalRow> {
    return fetchApi<ApprovalRow>(`demand-planning/approvals/${id}/decide/`, {
      method: 'POST',
      body: { status, decision_comment: comment ?? '' },
    });
  },
};
